import dayjs from 'dayjs';

export function timeOptionsSelect() {
  let now = dayjs();
  const slots = ((24 - now.hour()) * 60) / 15;
  const arr = Array(slots - 1).fill(0);
  now = now.minute(Math.ceil(now.minute() / 15) * 15);
  return arr.map((_) => {
    const value = now.format('DD-MMM-YYYY h:mm A');
    const display = now.local().format(`hh:mm A`);
    now = now.add(15, 'minute');
    return {
      Label: display,
      Value: value
    };
  });
}
